import React, { useState } from "react";
import { ShieldCheck } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import DncCheckPanel from "@/components/compliance/DncCheckPanel";

interface DncCheckButtonProps {
  phoneNumbers: string[];
  size?: "sm" | "icon";
  className?: string;
}

export default function DncCheckButton({ phoneNumbers, size = "sm", className }: DncCheckButtonProps) {
  const [open, setOpen] = useState(false);
  const numbers = phoneNumbers.filter((phoneNumber) => phoneNumber.trim().length > 0);

  return (
    <>
      <Button
        variant="outline"
        size={size}
        className={className}
        disabled={numbers.length === 0}
        title="Check Do Not Call lists"
        onClick={() => setOpen(true)}
      >
        <ShieldCheck className="h-3.5 w-3.5" />
        {size !== "icon" && <span className="ml-1">Check DNC</span>}
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle>Check Do Not Call lists</DialogTitle>
            <DialogDescription>
              Looks {numbers.length === 1 ? "this number" : `these ${numbers.length} numbers`} up on the national and
              state Do Not Call lists and known litigator lists. Numbers checked in the last 31 days are free.
            </DialogDescription>
          </DialogHeader>
          {open && <DncCheckPanel phoneNumbers={numbers} />}
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)}>
              Close
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
